// ============================================================================
// ОТЧЁТ ИЗ БРАУЗЕРА В «ПАДЕНИЯ».
// ----------------------------------------------------------------------------
// Одна дверь для всего, что браузер сообщает серверу: и перехваченные ошибки
// (instrumentation-client.ts), и то, что само по себе не ошибка, но ею
// является для человека, — например, данные, которые не пришли за разумное
// время. Второй способ отправки не заводим.
//
// keepalive: страница может закрываться прямо сейчас — обычный fetch тогда
// обрывается, а этот браузер доводит. Диагностика не имеет права шуметь:
// любые сбои отправки глотаются.
// ============================================================================

// ── КОНТЕКСТ БРАУЗЕРА ─────────────────────────────────────────────────────
// Расхождение разметки с сервером (React #418/#423/#425) бывает не только от
// нашего кода: переводчик браузера и расширения правят текст страницы до того,
// как React её «оживит». Чтобы отличить одно от другого по журналу, а не
// гадать, к записи добавляется строка: переведена ли страница, язык страницы
// и браузера, следы расширений, правящих текст, и браузер — без личных данных.
export function browserContext(): string {
  try {
    const html = document.documentElement
    const translated = html.classList.contains('translated-ltr') || html.classList.contains('translated-rtl')
      || !!document.querySelector('font[style*="vertical-align"], .goog-te-banner-frame, #goog-gt-tt')
    const editors = document.querySelector('grammarly-desktop-integration, [data-gramm], [data-lt-installed], [data-new-gr-c-s-check-loaded]')
    const ua = navigator.userAgent.match(/(Edg|OPR|YaBrowser|Firefox|Chrome|Safari)\/[\d.]+/)?.[0] ?? 'other'
    return `[ctx] translated=${translated ? 'yes' : 'no'} lang=${html.lang || '-'} nav=${navigator.language || '-'} editors=${editors ? 'yes' : 'no'} ua=${ua}`
  } catch {
    return '[ctx] unavailable'
  }
}

// Отправить запись в журнал падений от имени вошедшего пользователя.
export function sendClientReport(message: string, stack = ''): void {
  try {
    // Контекст — первой строкой: сервер режет стек до 2000 знаков с конца.
    const withCtx = browserContext() + '\n' + stack
    void fetch('/api/health/client-error', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message, stack: withCtx, path: window.location.pathname + window.location.search }),
      keepalive: true,
    }).catch(() => { /* молча */ })
  } catch {
    /* молча */
  }
}
